import React from 'react';
import PropTypes from 'prop-types';
import { Detail, Input } from 'components/common';
import MessageLoader from './MessageLoader';
import MessageActions from './MessageActions';
import useStreamValue from '../hooks/useStreamValue';

function Message({
  loading,
  disabled,
  value,
  isError,
  shouldStream,
  feedback,
  onFeedbackChange,
  logMessageInteraction,
  scrollToBottom,
}) {
  const [streamedValue, isStreaming] = useStreamValue(value, shouldStream);

  return (
    <Detail
      label='Message'
      style={{ position: 'relative', marginBottom: '8px', fontSize: '14px' }}
    >
      <div style={{ position: 'relative' }}>
        <Input
          multiline
          readOnly
          rows={12}
          value={streamedValue}
          disabled={disabled}
          style={{
            minHeight: '250px',
            paddingRight: '32px',
            color: isError ? 'red' : '',
          }}
        />
        {loading && (
          <MessageLoader
            style={{
              position: 'absolute',
              top: '1px',
              left: '1px',
              width: 'calc(100% - 2px)',
              height: 'calc(100% - 2px)',
            }}
          />
        )}
      </div>
      <MessageActions
        disabled={disabled}
        isStreaming={isStreaming}
        value={streamedValue}
        feedback={feedback}
        onFeedbackChange={onFeedbackChange}
        logMessageInteraction={logMessageInteraction}
        loading={loading}
        scrollToBottom={scrollToBottom}
      />
    </Detail>
  );
}

Message.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  isError: PropTypes.bool,
  shouldStream: PropTypes.bool,
  feedback: PropTypes.string,
  onFeedbackChange: PropTypes.func.isRequired,
  logMessageInteraction: PropTypes.func.isRequired,
  scrollToBottom: PropTypes.func,
};

export default Message;
